import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { CommandUniformMap } from "../../DriverDesign/RenderDevice/CommandUniformMap";
export class WebGLCommandUniformMap extends CommandUniformMap {
    constructor(stateName) {
        super(stateName);
        this._idata = new Map();
        this._stateName = stateName;
        this._stateID = Shader3D.propertyNameToID(stateName);
    }
    hasPtrID(propertyID) {
        return this._stateID == propertyID || this._idata.has(propertyID);
    }
    addShaderUniform(propertyID, propertyKey, uniformtype) {
        this._idata.set(propertyID, { id: propertyID, uniformtype: uniformtype, propertyName: propertyKey, arrayLength: 0 });
    }
    addShaderUniformArray(propertyID, propertyName, uniformtype, arrayLength, block = "") {
        this._idata.set(propertyID, { id: propertyID, uniformtype: uniformtype, propertyName: propertyName, arrayLength: arrayLength });
    }
}
